import React, { useEffect, useState } from 'react';
import { Button, Card, Spin } from "antd";
import { CloseOutline } from 'antd-mobile-icons';
import axios from 'axios';
import { Document, Page, pdfjs } from 'react-pdf';
import { useSelector } from 'react-redux';
import { useMediaQuery } from "react-responsive";
import userapiservice from "../../api/userapiservice";
import './viewAndDownloadBrochure.scss';


const ViewAndDownloadBrochure = ({ state, onLoadComplete }) => {
  const localData = useSelector((state) => state?.localStorage)
  const { accessToken } = localData
  const [viewLoading, SetViewLoading] = useState();
  const [downloadLoading, SetDownloadLoading] = useState();
  const isSmallScreen = useMediaQuery({ minWidth: 320, maxWidth: 767 });

  const [fileType, setFileType] = useState();
  const [pdfContent, setPdfContent] = useState(null);
  const [viewModalVisible, setViewModalVisible] = useState(false);

  const [pdfDataResponse, setPdfDataResponse] = useState();
  const [pdfDataResponseLoading, setPdfDataResponseLoading] = useState(true);

  const [pdfFirstPageUrl,] = useState("");

  const [pageNumber, setPageNumber] = useState(1);
  const [pdfString, setPdfString] = useState("");
    const [numPages, setNumPages] = useState(null);

  const getDownloadBrochureData = async () => {
    SetDownloadLoading(true);
    try {
      if (pdfDataResponse) {
        const fileName = state.data.brochureFileName
          ? state.data.brochureFileName
          : `${state.data.assetTitle}.pdf`;
        const blob = new Blob([pdfDataResponse.data]);
        const downloadLink = document.createElement("a");
        downloadLink.href = URL.createObjectURL(blob);
        downloadLink.download = fileName;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    } catch (error) {
      console.log("error downloading pdf from blob", error);
    } finally {
      SetDownloadLoading(false);
    }
  };



  // const getViewBrochureData = async () => {
  //   SetViewLoading(true);
  //   try {
  //     if (pdfDataResponse) {
  //       setFileType(pdfDataResponse.data.type);
  //       const blob = new Blob([pdfDataResponse.data], {
  //         type: "application/pdf",
  //       });
  //       const pdfUrl = URL.createObjectURL(blob);
  //       setPdfContent(pdfUrl);
  //       setViewModalVisible(true);
  //     }
  //   } catch (error) {
  //     console.log("error viewing pdf from blob", error);
  //   } finally {
  //     SetViewLoading(false);
  //   }
  // };

  // chagt gpt
  const getViewBrochureData = async () => {
    SetViewLoading(true);
    try {
      if (!pdfDataResponse) {
        console.warn("No pdfDataResponse yet");
        return;
      }

      setFileType(pdfDataResponse.data.type);

      // prefer in-app viewer on small screens using the already-read base64 (pdfString)
      if (isSmallScreen && pdfString) {
        setPdfContent(`data:application/pdf;base64,${pdfString}`);
        setViewModalVisible(true);
        return;
      }

      // fallback: create blob URL and open in new tab / iframe (desktop)
      const blob = new Blob([pdfDataResponse.data], { type: "application/pdf" });
      const pdfUrl = URL.createObjectURL(blob);
      setPdfContent(pdfUrl);
      try {
        const newWin = window.open(pdfUrl, "_blank");
        if (!newWin) {
          const a = document.createElement("a");
          a.href = pdfUrl;
          a.target = "_blank";
          a.rel = "noopener noreferrer";
          document.body.appendChild(a);
          a.click();
          a.remove();
        }
      } catch (err) {
        window.location.href = pdfUrl;
      }
    } catch (error) {
      console.error("error viewing pdf", error);
    } finally {
      SetViewLoading(false);
    }
  };


  function onDocumentLoadSuccess({ numPages: n }) {
    setNumPages(n);
    setPageNumber(1);
  }

  useEffect(() => {
    const currentHost = window.location.host;
    const protocol = window.location.protocol;
    let workerSrc = `${protocol}//${currentHost}/pdf.worker.min.js`;
    pdfjs.GlobalWorkerOptions.workerSrc = new URL(
      workerSrc,
      import.meta.url
    ).toString();
  }, []);

  useEffect(() => {
    const getPdfBlob = async () => {
      setPdfDataResponseLoading(true);
      try {
        const authToken = accessToken;
        const response = await axios.get(
          userapiservice.downloadBrochure(state.data.id),
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
            responseType: "blob",
          }
        );
        if (response) {
          setPdfDataResponse(response);

          //////////////////////////////////
          if (response.data instanceof Blob) {
            const blob = response.data;
            let reader = new FileReader();

            reader.readAsDataURL(blob);
            reader.onloadend = () => {
              const base64String = reader.result;
              setPdfString(base64String.substr(base64String.indexOf(",") + 1));
            };
          } else {
            console.error("Response data is not a Blob");
          }
          //////////////////////////////////
        }
      } catch (error) {
        console.log("error downloading pdf", error);
      } finally {
        setPdfDataResponseLoading(false);
        onLoadComplete();
      }
    };
    getPdfBlob();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  return (
    <div
      className="brochure"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: isSmallScreen && "10px",
        // marginLeft:"12vw"
      }}
    >
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.6.347/pdf_viewer.min.css"
      />

      <Card className="brochure-card">
        <h4
          className="brochured-header-text"
          style={{
            paddingLeft: isSmallScreen && "10px",
            margin: 0,
            marginBottom: "10px",
          }}
        >
          Brochure
        </h4>
        {pdfDataResponseLoading ? (
          <div className="no-data-warning">
            <Spin tip="Loading" size="large" />
          </div>
        ) : (
          <div style={{ display: "flex" }}>
            <div
              style={{
                border: "1px solid #0000001f",
                borderRadius: "6px",
                padding: "10px",
              }}
            >
              {pdfDataResponse && !pdfString && (
                <img
                  className="fade-in"
                  style={{ width: "200px" }}
                  src={
                    pdfFirstPageUrl !== ""
                      ? pdfFirstPageUrl
                      : state.data.micrositeLogo
                  }
                  alt="pdf First Page"
                />
              )}

              <div style={{ width: "250px" }}>
                {pdfDataResponse && pdfString && (
                  <Document
                    file={`data:application/pdf;base64,${pdfString}`}
                    onLoadSuccess={onDocumentLoadSuccess}
                    className="fade-in"
                  >
                    <Page pageNumber={pageNumber} />
                  </Document>
                )}
              </div>
              {/* 
                <h3
                  className="pdf-file-name"
                  style={{ fontSize: "16px", textAlign: "center" }}
                >
                  {state.data.brochureFileName
                    ? truncateFilename(state.data.brochureFileName, 20)
                    : `${state.data.assetTitle}.pdf`}
                </h3> */}
              <div
                className="brochure-buttons"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Button
                  className="brochure-bt"
                  style={{ background: "#3067AE" }}
                  loading={viewLoading}
                  onClick={getViewBrochureData}
                  type="primary"
                >
                  View
                </Button>
                <Button
                  className="brochure-bt"
                  style={{ background: "#3067AE" }}
                  loading={downloadLoading}
                  type="primary"
                  onClick={getDownloadBrochureData}
                >
                  Download
                </Button>
              </div>
            </div>
          </div>
        )}
      </Card>

      {viewModalVisible && (
        <>
          <div
            className="custom-modal-overlay"
            onClick={() => {
              setViewModalVisible(false);
            }}
          ></div>
          <div
            className="custom-modal"
            style={{ width: isSmallScreen ? "90vw" : "80vw" }}
          >
            <div className="custom-modal-header">
              <span className="custom-modal-title">View Attachment</span>
              <button
                className="custom-close-button"
                onClick={() => {
                  setViewModalVisible(false);
                }}
              >
                <CloseOutline />
              </button>
            </div>
            <div>
              {/* {pdfContent && fileType === "application/pdf" && (
                <iframe
                  className="pdf-viewer"
                  src={pdfContent}
                  title="PDF Viewer"
                // style={{ width: '100%', height: '70vh', position: 'relative' }}
                />
              )} */}
              {pdfContent && fileType === "application/pdf" && isSmallScreen && pdfString && (
                <div style={{ overflowY: "auto", maxHeight: "75vh", padding: "10px" }}>
                  <Document
                    file={pdfContent}
                    onLoadSuccess={({ numPages: n }) => {
                      setNumPages(n);
                      setPageNumber(1);
                    }}
                  >
                    {Array.from({ length: numPages || 1 }, (_, idx) => (
                      <Page
                        key={`page_${idx + 1}`}
                        pageNumber={idx + 1}
                        width={Math.min(window.innerWidth * 0.9, 800)}
                      />
                    ))}
                  </Document>
                </div>
              )}

              {pdfContent && fileType === "application/pdf" && !isSmallScreen && (
                <iframe
                  className="pdf-viewer"
                  src={pdfContent}
                  title="PDF Viewer"
                  style={{ width: "100%", height: "70vh", border: "none" }}
                />
              )}

            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ViewAndDownloadBrochure